import { memo, useCallback } from 'react';
import TabsPicker, { TabsPickerProps } from 'modules/bottomPanel/components/elements/TabsPicker';

interface MaxChannelWidthPickerProps {
  disabled?: boolean;
  value: number;
  options: TabsPickerProps['options'];
  onChange: (newValue: number) => void;
}

const MaxChannelWidthPickerImpl = (props: MaxChannelWidthPickerProps) => {
  const { disabled, value, options, onChange: onChangeProp } = props;

  const stringValue = String(value);
  const onChange = useCallback(
    (newValue: string) => {
      onChangeProp(Number(newValue));
    },
    [onChangeProp]
  );

  return (
    <TabsPicker
      isDisabled={disabled}
      label="Max Channel Width (MHz)"
      onChange={onChange}
      options={options}
      value={stringValue}
    />
  );
};

const MaxChannelWidthPicker = memo(MaxChannelWidthPickerImpl);

export default MaxChannelWidthPicker;
